csui.require.config({
  bundles: {
'smart/bundles/smart-all': [
'smart/themes/theming',
'smart/lib/binf/js/binf',
'smart/behaviors/keyboard.navigation/smart.tabables.behavior',
'smart/behaviors/keyboard.navigation/smart.tabable.region.behavior',
'smart/themes/carbonfiber/smart.mimetype.icons',
'smart/themes/carbonfiber/smart.mimetype.colorschema.icons',
'smart/themes/carbonfiber/smart.action.icons',
'smart/utils/high.contrast/detector',
'smart/controls/icons.v2/impl/core.smart.icons.v2',
'smart/controls/icon/icon.view',
'smart/controls/icons.v2/icons.v2',
'smart/mixins/generic.utilities/footerview.responsiveness.mixin',
'smart/mixins/generic.utilities/headerview.responsiveness.mixin',
'smart/mixins/dropdown/dropdown.view',
'smart/mixins/layoutview.events.propagation/layoutview.events.propagation.mixin',
'smart/mixins/view.events.propagation/view.events.propagation.mixin',
'smart/utils/smart.base',
'smart/controls/breadcrumbs/breadcrumbs.view',
'smart/controls/breadcrumbs/breadcrumb.view',
'smart/controls/bulk.selection/bulk.selection.dropdown.item.view',
'smart/controls/bulk.selection/bulk.selection.dropdown.view',
'smart/controls/bulk.selection/bulk.selection.view',
'smart/controls/error/error.view',
'smart/controls/dialog/dialog.view',
'smart/controls/dialog/footer.view',
'smart/controls/dialog/header.view',
'smart/controls/globalmessage/globalmessage',
'smart/controls/pagination/nodespagination.view',
'smart/controls/pagination/impl/nls/root/localized.strings',
'smart/controls/progressblocker/blocker',
'smart/controls/progresspanel/progresspanel',
'smart/controls/progresspanel/progresspanel/progresspanel.view',
'smart/controls/progresspanel/progresspanel.view.ext',
'smart/controls/side.panel/side.panel.view',
'smart/controls/side.panel/impl/side.panel.util',
'smart/controls/inline.panel/inline.panel.view',
'smart/controls/table.settings/table.settings.columns.side.panel.view',
'smart/controls/tab.panel/tab.panel.view',
'smart/controls/tab.panel/tab.contents.view',
'smart/controls/tab.panel/tab.content.view',
'smart/controls/tab.panel/tab.links.ext.view',
'smart/controls/tab.panel/tab.link.ext.view',
'smart/controls/tab.panel/tab.link.view',
'smart/controls/tab.panel/tab.links.view',
'smart/controls/tab.panel/tab.links.ext.scroll.mixin',
'smart/controls/tab.panel/tab.contents.header.view',
'smart/controls/facet.bar/facet.bar.view',
'smart/controls/facet.panel/facet.panel.view',
'smart/controls/user/miniprofile.view',
'smart/controls/user/user.profile.view',
'smart/controls/user/user.profile.tabs.view',
'smart/dialogs/modal.alert/modal.alert',
'smart/dialogs/impl/button/button.view',
'smart/dialogs/modal.alert/impl/nls/root/lang',
'smart/controls/list/list.view',
'smart/controls/list/simplelist.view',
'smart/controls/list/simpletreelist.view',
'smart/controls/list/behaviors/list.view.keyboard.behavior',
'smart/controls/listitem/listitemstandard.view',
'smart/controls/listitem/simpletreelistitem.view',
'smart/controls/list/behaviors/list.item.keyboard.behavior',
'smart/controls/emptylist/emptylist.view',
'smart/controls/list/list.state/list.state.view',
'smart/behaviors/collection.state/collection.state.view',
'smart/controls/node.picker/node.picker',
'smart/utils/non-emptying.region/non-emptying.region',
'smart/utils/otwc.loader',
'smart/utils/accessibility',
'smart/themes/carbonfiber/ot-icons/icons_smart_action',
'smart/themes/carbonfiber/ot-icons/icons_smart_action_16',
'smart/themes/carbonfiber/ot-icons/icons_smart_action_small',
'smart/themes/carbonfiber/ot-icons/icons_smart_mime',
'smart/themes/carbonfiber/ot-icons/icons_smart_notification',
'smart/themes/jato.icons/smart.jato.action.icons',
'smart/themes/jato.icons/smart.jato.illustrations',
'smart/behaviors/app.header/app.header.control.behavior',
'smart/behaviors/collection.state/collection.state.behavior',
'smart/controls/app.header/app.header.controls',
'smart/controls/app.header/app.header.view',
'smart/controls/app.header/panel/smart.panel.view',
'smart/controls/app.header/panel/groups/groups.view',
'smart/controls/skip.links/skip.links',
'smart/controls/app.header/panel/groups/smart.theme.group',
'smart/controls/image.cropper/image.cropper.view'
],
'smart/bundles/icons-smart-action': [
'smart/themes/carbonfiber/ot-icons/icons_smart_action'
],
'smart/bundles/icons-smart-action_16': [
'smart/themes/carbonfiber/ot-icons/icons_smart_action_16'
]
  }
});